import { Link } from "react-router-dom";
import { Hammer } from "lucide-react";
import Reveal from "@/components/Reveal";
import { COLLECTION } from "@/data/site";

export default function Collection() {
  return (
    <div data-testid="collection-page">
      <section className="parchment border-b border-[color:var(--accent)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <Reveal>
            <div className="eyebrow mb-6">The Collection · Eleven motor cars</div>
            <h1 className="font-display text-6xl md:text-8xl tracking-tighter leading-[0.95]">
              A garage of <span className="italic text-[color:var(--brg)]">rarities,</span>
              <br />kept moving.
            </h1>
          </Reveal>
          <Reveal delay={150}>
            <p className="mt-10 text-lg md:text-xl text-[color:var(--ink-secondary)] max-w-3xl leading-relaxed">
              Each car has been chosen for its character rather than its market value. They are moderately valuable but generously rewarding. Click any motor for its full story and photo gallery.
            </p>
          </Reveal>
        </div>
      </section>

      <section className="bg-[color:var(--surface)]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-16">
            {COLLECTION.map((car, idx) => (
              <Reveal key={car.slug} delay={(idx % 3) * 80}>
                <Link
                  to={`/collection/${car.slug}`}
                  data-testid={`car-card-${car.slug}`}
                  className="text-left w-full group block"
                >
                  <div className="tile aspect-[4/3] mb-5 relative">
                    <img
                      src={car.image}
                      alt={`${car.year} ${car.make} ${car.model}`}
                      className="w-full h-full object-cover"
                      loading="lazy"
                    />
                    {car.status && (
                      <div className="absolute top-3 left-3 flex items-center gap-2 bg-[color:var(--oxblood)] text-[color:var(--bg)] px-3 py-1.5 text-[0.65rem] uppercase tracking-[0.2em]">
                        <Hammer size={11} /> In restoration
                      </div>
                    )}
                  </div>
                  <div className="flex items-baseline justify-between">
                    <div className="font-display italic text-[color:var(--brg)] text-xl">
                      №{String(idx + 1).padStart(2, "0")}
                    </div>
                    <div className="text-xs tracking-[0.22em] uppercase text-[color:var(--ink-muted)]">
                      {car.year}
                    </div>
                  </div>
                  <div className="font-display text-3xl tracking-tight mt-2 group-hover:text-[color:var(--brg)] transition">
                    {car.make} <span className="italic">{car.model}</span>
                  </div>
                  <div className="text-sm text-[color:var(--ink-muted)] mt-2 leading-relaxed">
                    {car.note}
                  </div>
                </Link>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
